import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import { Logos } from "../components/Shared/Logos";
import dayjs from "dayjs";
import pdfStyles, { saleReportStyles } from "./pdfStyles";
import print from "../assets/images/print.png";
import email from "../assets/images/email.png";
import phone from "../assets/images/phone.png";

/** Hide null/undefined/empty strings saved in localStorage (e.g. literal "null"). */
export const displayHeaderValue = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text.toLowerCase() === "null" || text.toLowerCase() === "undefined") {
    return "";
  }
  return text;
};

function PrintHeaderAccount({ compact = false }) {
  const styles = compact ? saleReportStyles : pdfStyles;

  const pumpName = displayHeaderValue(localStorage.getItem("PumpName"));
  const emailAddress = displayHeaderValue(localStorage.getItem("Email_Address"));
  const mobileNo = displayHeaderValue(localStorage.getItem("Mobile_No"));
  const address = displayHeaderValue(localStorage.getItem("Address"));
  const pumpLogo = displayHeaderValue(localStorage.getItem("pumpLogo"));

  const matchingLogo = pumpLogo
    ? Logos.find((logo) => logo.title.toLowerCase() === pumpLogo.toLowerCase())
    : null;

  const logoSize = compact ? 38 : 50;
  const contactRows = [
    emailAddress ? { text: emailAddress, icon: email } : null,
    mobileNo ? { text: mobileNo, icon: phone } : null,
    {
      text: `Printed ${dayjs().format("DD MMM YYYY, hh:mm A")}`,
      icon: print,
    },
  ].filter(Boolean);

  return (
    <View style={styles.header} fixed>
      <View style={styles.headerLeft}>
        {matchingLogo ? (
          <Image
            source={matchingLogo.src}
            style={{ width: logoSize, height: logoSize }}
          />
        ) : (
          <View style={styles.headerLogoPlaceholder}>
            <Text style={styles.headerLogoPlaceholderText}>Logo</Text>
          </View>
        )}
        <View style={styles.headerBrand}>
          {pumpName ? <Text style={styles.headerinfo}>{pumpName}</Text> : null}
          {address ? <Text style={styles.headerAddress}>{address}</Text> : null}
        </View>
      </View>

      <View style={styles.headerRight}>
        {contactRows.map((row, index) => (
          <View key={index} style={styles.headerContactRow}>
            <Text style={styles.contenttitle}>{row.text}</Text>
            <Image source={row.icon} style={styles.contentimg} />
          </View>
        ))}
      </View>
    </View>
  );
}

export default PrintHeaderAccount;
